import React, { useState } from 'react';
import './index.scss';
import { useDispatch } from 'react-redux';
import { login } from '../../../api/redux/slices/Auth';
import { RotatingSquare } from 'react-loader-spinner';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { icons } from '../../../assets/icons';
import { showToast } from '../../../components/modal';
import logoImage from '../../../assets/jeunessee.png';
import PageWrapper from '../../../components/PageWrapper';

const LoginSchema = Yup.object().shape({
    email: Yup.string().required('Email est requis').email('Email invalide'),
    password: Yup.string()
        .required('Mot de passe est requis')
        .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
});

const Login = () => {
    const [load, setLoad] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [passwordVisible, setPasswordVisible] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
    } = useForm();

    const onSubmit = (data) => {
        LoginSchema.validate(data, { abortEarly: false })
            .then(() => {
                setLoad(true);
                dispatch(login(data))
                    .unwrap()
                    .then((res) => {
                        if (res.data.user.is_active === false) {
                            showToast('Utilisateur bloqué', 'info');
                        } else {
                            localStorage.setItem('accesstoken', res.data.token);
                            toast.success('Connexion réussie', {
                                position: 'top-center',
                                autoClose: 2000,
                            });
                            navigate('/');
                        }
                    })
                    .catch((err) => {
                        toast.error(err.message, {
                            position: 'top-center',
                            autoClose: 2000,
                        });
                    })
                    .finally(() => setLoad(false));
            })
            .catch((validationErrors) => {
                validationErrors.inner.forEach((error) => {
                    setError(error.path, { message: error.message });
                });
            });
    };

    const togglePassword = () => {
        const x = document.getElementById('passwordInput');
        if (x.type === 'password') {
            x.type = 'text';
            setPasswordVisible(true);
        } else {
            x.type = 'password';
            setPasswordVisible(false);
        }
    };

    return (
        <div className="jeuness-login">
            <div className="jeuness-login-container">
                {/* LEFT SIDE - Branding / Hero */}
                <div className="jeuness-login-brand">
                    <div className="brand-content">
                        <Link to="/" className="brand-logo">
                            <img src={logoImage} alt="JEUN'ESS" />
                            <span>JEUN'ESS</span>
                        </Link>
                        
                        <div className="brand-quote">
                            <div className="quote-icon">🌱</div>
                            <h2>L'économie sociale<br />au service de la jeunesse</h2>
                            <p>Plateforme collaborative dédiée aux produits de l'Économie Sociale et Solidaire en Tunisie.</p>
                        </div>
                    </div>
                    
                    {/* Decorative elements */}
                    <div className="brand-decor">
                        <div className="decor-circle decor-1"></div>
                        <div className="decor-circle decor-2"></div>
                        <div className="decor-circle decor-3"></div>
                        <div className="decor-wave"></div>
                    </div>
                </div>

                {/* RIGHT SIDE - Login Form */}
                <div className="jeuness-login-form">
                    <div className="form-card">
                        <div className="form-header">
                            <span className="form-badge">🔐 Accès sécurisé</span>
                            <h2>Connexion</h2>
                            <p>Entrez vos identifiants pour accéder à votre espace</p>
                        </div>

                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="form-group">
                                <label>Email professionnel</label>
                                <div className="input-wrapper">
                                    <span className="input-icon">📧</span>
                                    <input 
                                        type="email" 
                                        placeholder="exemple@entreprise.com"
                                        {...register('email')}
                                    />
                                </div>
                                {errors.email && <span className="error-message">{errors.email.message}</span>}
                            </div>

                            <div className="form-group">
                                <label>Mot de passe</label>
                                <div className="input-wrapper">
                                    <span className="input-icon">🔒</span>
                                    <input
                                        id="passwordInput"
                                        type={passwordVisible ? 'text' : 'password'}
                                        placeholder="••••••••"
                                        {...register('password')}
                                    />
                                    <button type="button" className="password-toggle" onClick={togglePassword}>
                                        {passwordVisible ? <icons.BsEyeSlash /> : <icons.BsEye />}
                                    </button>
                                </div>
                                {errors.password && <span className="error-message">{errors.password.message}</span>}
                            </div>

                            <button type="submit" className="btn-login" disabled={load}>
                                {load ? (
                                    <RotatingSquare
                                        ariaLabel="rotating-square"
                                        visible={true}
                                        color="#1A5D3A"
                                        size={24}
                                    />
                                ) : (
                                    "Se connecter"
                                )}
                            </button>
                        </form>
                        
                        <div className="form-footer">
                            <div className="register-link">
                                Pas encore de compte ? <Link to="/register">Créer un compte</Link>
                            </div>
                            <Link to="/" className="home-link">
                                <span>←</span> Retour à l'accueil
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const LoginPage = () => <PageWrapper><Login /></PageWrapper>;
export default LoginPage;